/** Settlement policies change labor priorities; all work still happens in-world. */
export type VillageFocus = 'balanced' | 'food' | 'industry'
export interface GovernorState { enabled: boolean; focus: VillageFocus; status: string }
export const VILLAGE_FOCUS: Record<VillageFocus, { name: string; desc: string }> = {
  balanced: { name: 'Balanced village', desc: 'Staff food production first, then spread workers across your other buildings.' },
  food: { name: 'Feed and grow', desc: 'Fill farms and fishing piers before expanding industry.' },
  industry: { name: 'Build and produce', desc: 'Favor quarries and mines while keeping a food crew working.' },
}
export function governorEnabled(f: { governor?: GovernorState }): boolean { return f.governor?.enabled !== false }
